import React, { PureComponent } from 'react';

import type { CustomGlyphProps, GlyphProps } from '@atlaskit/icon/types';
import Icon from '@atlaskit/icon';

const WhiteboardsGlyph = (props: CustomGlyphProps) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		data-testid={props['data-testid']}
		aria-label={props['aria-label']}
		// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
		className={props.className}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M17.4676 19.0003H12.5324L15 14.8876L17.4676 19.0003ZM16.2862 13.144L19.6369 18.7286C20.2368 19.7283 19.5167 21.0003 18.3507 21.0003L11.6493 21.0003C10.4833 21.0003 9.76317 19.7283 10.363 18.7286L13.7138 13.144C14.2964 12.173 15.7036 12.173 16.2862 13.144Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.25 14.2503C8.49264 14.2503 9.5 13.2429 9.5 12.0003C9.5 10.7577 8.49264 9.75031 7.25 9.75031C6.00736 9.75031 5 10.7577 5 12.0003C5 13.2429 6.00736 14.2503 7.25 14.2503ZM7.25 16.2503C9.59721 16.2503 11.5 14.3475 11.5 12.0003C11.5 9.6531 9.59721 7.75031 7.25 7.75031C4.90279 7.75031 3 9.6531 3 12.0003C3 14.3475 4.90279 16.2503 7.25 16.2503Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M15.9361 3.40145C14.2555 2.48132 11.8822 3.16052 10.2366 5.10518C9.87988 5.52678 9.93245 6.15776 10.354 6.51451C10.7756 6.87127 11.4066 6.8187 11.7634 6.3971C13.0283 4.9023 14.4091 4.84557 14.9756 5.15572C14.9993 5.16869 15.0201 5.1806 15.0382 5.19143C14.9972 5.26779 14.9312 5.3708 14.8278 5.50284C14.6006 5.79293 14.229 6.17746 13.6469 6.67735C13.2478 7.02006 12.8099 7.52262 12.8139 8.1797C12.8184 8.9345 13.3745 9.33929 13.7094 9.50462C14.0662 9.6807 14.4679 9.75263 14.7932 9.77204C15.094 9.78999 15.5049 9.77377 15.8504 9.62542C17.5125 8.91169 18.3205 9.12304 18.6232 9.33514C18.8948 9.52545 19.1194 9.98403 18.9338 10.7707C18.807 11.3082 19.14 11.8468 19.6775 11.9736C20.215 12.1004 20.7536 11.7675 20.8804 11.2299C21.1753 9.97981 20.9549 8.52694 19.771 7.69727C18.7399 6.97474 17.3048 6.96469 15.6547 7.55398C15.9549 7.26219 16.2029 6.99071 16.4024 6.73599C16.7333 6.31351 16.9847 5.86937 17.065 5.39911C17.1546 4.87409 17.015 4.40783 16.7331 4.0436C16.4861 3.72432 16.1615 3.52487 15.9361 3.40145Z"
			fill="currentColor"
		/>
	</svg>
);

export class WhiteboardsIcon extends PureComponent<GlyphProps> {
	render() {
		return <Icon {...this.props} glyph={WhiteboardsGlyph} />;
	}
}
